import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

// The /api/** rewrites are served before index.html, so only the UI redirects. Customers still open
// support.firsty.app/intercom[/:userId] from the app's web and mini-app builds.
if (!window.location.pathname.startsWith("/intercom")) {
  window.location.replace(environment.partnerAreaBaseUrl);
} else {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}
